<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="table" v-if="NodeInclude('27')">
      <div class="filterwrap">
        <div data-v-452b50d7="" style="font-size: 24px; font-weight: 700;">
          <!-- 年度汇总数据 -->
        </div>
        <div class="b-filter">
          <div style="margin-right: 10px;">更新时间：{{ update_time }}</div>
          <el-button round @click="updateFn" v-if="NodeInclude('28')">手动更新</el-button>
        </div>
      </div>

      <!-- 本年之前的汇总表 -->
      <div class="items" v-if="oldYearList.length > 0">
        <div class="item">
          <div class="item-title">数据总览</div>
          <el-table :data="oldYearList" border style="width: 100%;" class="item-table" :row-class-name="tableRowClassName">
            <el-table-column prop="index" label="" header-align="center" align="center" min-width="120">
              <template slot-scope="scope">
                <div class="showDiv" style="cursor: default;">
                  <div>
                    {{ scope.row.project_type == '1' ? `客户项目` : (scope.row.project_type == '2' ? `行政采购` :
                      (scope.row.project_type == '3' ? `人力资源` :
                        (scope.row.project_type == '4' ? `报销管理` : `${scope.row.year}年合计`))) }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="total_amount" label="合同金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <div class="showDiv" style="cursor: default;">
                  <div>{{ scope.row.total_amount }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="total_invoice" label="已开票金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '3', '')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.total_invoice
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="unfinished_invoice" label="未开票金额" header-align="center" align="right"
              min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '1', '')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.unfinished_invoice }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="received_amount" label="已收款金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '', '3')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.received_amount }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="unreceived_amount" label="未收款金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '', '1')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.unreceived_amount }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_unreceive" label="已开票未收款金额" header-align="center" align="right"
              min-width="120">
              <template slot-scope="scope">
                <div style="cursor: default;">{{ scope.row.invoice_unreceive }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="total_budget" label="预算" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '')"
                  :style="{ 'cursor': (scope.row.project_type != '4' && scope.row.id) ? 'pointer' : 'default' }">{{ scope.row.total_budget
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_cost" label="成本" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '')"
                  :style="{ 'cursor': (scope.row.project_type != '4' && scope.row.id) ? 'pointer' : 'default' }">{{ scope.row.total_cost
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_paid" label="已支付" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '3')"
                  :style="{ 'cursor': (scope.row.project_type != '4' && scope.row.id) ? 'pointer' : 'default' }">{{ scope.row.total_paid
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_no_paid" label="未支付" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '1')"
                  :style="{ 'cursor': (scope.row.project_type != '4' && scope.row.id) ? 'pointer' : 'default' }">{{
                    scope.row.total_no_paid
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" header-align="center" align="center" min-width="100" fixed="right">
              <template slot-scope="scope">
                <div class="linkwrap">
                  <span class="link">
                    <el-button v-if="scope.row.project_type != '1' && scope.row.project_type != '2' && scope.row.project_type != '3' && scope.row.project_type != '4'"
                      size="mini"
                      type="text"
                      @click="toggleYearExpand(scope.row.year)">
                      {{ expandYearList.includes(scope.row.year) ? '收起' : '展开' }}<i :class="expandYearList.includes(scope.row.year) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-left: 5px;"></i>
                    </el-button>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 本年单独表 -->
      <!-- <div class="items" v-if="currentYearList.length > 0">
        <div class="item">
          <div class="item-title">{{ yearNow }}年数据总览</div>
          <el-table :data="currentYearList" border stripe style="width: 100%;" class="item-table">
            <el-table-column prop="index" label="项目类型" header-align="center" align="center" min-width="120">
              <template slot-scope="scope">
                <div class="showDiv">
                  <div>{{ scope.row.project_type == '1' ? '客户项目' : (scope.row.project_type == '2' ? '行政采购' :
                    (scope.row.project_type == '3' ? '人力资源' :
                      (scope.row.project_type == '4' ? '报销管理' : '合计'))) }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="total_amount" label="合同金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <div class="showDiv">
                  <div>{{ scope.row.total_amount }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="total_invoice" label="已开票金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '3', '')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.total_invoice
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="unfinished_invoice" label="未开票金额" header-align="center" align="right"
              min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '1', '')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.unfinished_invoice }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="received_amount" label="已收款金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '', '3')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.received_amount }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="unreceived_amount" label="未收款金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '', '1')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.unreceived_amount }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_unreceive" label="已开票未收款金额" header-align="center" align="right"
              min-width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.invoice_unreceive }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="total_budget" label="预算" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{ scope.row.total_budget
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_cost" label="成本" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{ scope.row.total_cost
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_paid" label="已支付" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '3')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{ scope.row.total_paid
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_no_paid" label="未支付" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '1')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{
                    scope.row.total_no_paid
                  }}</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div> -->

      <!-- 下一年及以后数据单独表 -->
      <!-- <div class="items" v-if="nextYearList.length > 0">
        <div class="item">
          <div class="item-title">{{ yearNow + 1 }}年数据总览</div>
          <el-table :data="nextYearList" border stripe style="width: 100%;" class="item-table">
            <el-table-column prop="index" label="项目类型" header-align="center" align="center" min-width="120">
              <template slot-scope="scope">
                <div class="showDiv">
                  <div>{{ scope.row.project_type == '1' ? `年客户项目` : (scope.row.project_type == '2' ? `行政采购` :
                    (scope.row.project_type == '3' ? `人力资源` :
                      (scope.row.project_type == '4' ? `报销管理` : `合计`))) }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="total_amount" label="合同金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <div class="showDiv">
                  <div>{{ scope.row.total_amount }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="total_invoice" label="已开票金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '3', '')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.total_invoice
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="unfinished_invoice" label="未开票金额" header-align="center" align="right"
              min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '1', '')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.unfinished_invoice }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="received_amount" label="已收款金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '', '3')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.received_amount }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="unreceived_amount" label="未收款金额" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type == '1' && toApply(scope.row.year, '', '1')"
                  :style="{ 'cursor': scope.row.project_type == '1' ? 'pointer' : 'default' }">{{
                    scope.row.unreceived_amount }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_unreceive" label="已开票未收款金额" header-align="center" align="right"
              min-width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.invoice_unreceive }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="total_budget" label="预算" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{ scope.row.total_budget
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_cost" label="成本" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{ scope.row.total_cost
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_paid" label="已支付" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '3')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{ scope.row.total_paid
                  }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="total_no_paid" label="未支付" header-align="center" align="right" min-width="120">
              <template slot-scope="scope">
                <a @click="scope.row.project_type != '4' && toPay(scope, '1')"
                  :style="{ 'cursor': scope.row.project_type != '4' ? 'pointer' : 'default' }">{{
                    scope.row.total_no_paid
                  }}</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div> -->
    </div>

    <div class="tabpart">
      <div class="top" :class="{ 'margin': !isLong }">
        <div class="topbar" style="cursor: pointer;">
          <div class="tab" :class="{ 'active': mType == 1 }" @click="topTabFn(1)" v-if="MenuInclude('2')">
            <p>客户项目<span class="ico-red" v-if="projectUnread != '0'">{{ projectUnread }}</span></p>
          </div>
          <div class="tab" :class="{ 'active': mType == 2 }" @click="topTabFn(2)" v-if="MenuInclude('8')">
            <p>行政采购<span class="ico-red" v-if="adminUnread != '0'">{{ adminUnread }}</span></p>
          </div>
          <div class="tab" :class="{ 'active': mType == 3 }" @click="topTabFn(3)" v-if="MenuInclude('12')">
            <p>人力资源<span class="ico-red" v-if="hrUnread != '0'">{{ hrUnread }}</span></p>
          </div>
          <div class="tab" :class="{ 'active': mType == 4 }" @click="topTabFn(4)" v-if="MenuInclude('16')">
            <p>报销管理<span class="ico-red" v-if="expenseUnread != '0'">{{ expenseUnread }}</span></p>
          </div>
          <div class="tab" :class="{ 'active': mType == 5 }" @click="topTabFn(5)" v-if="MenuInclude('16')">
            <p>休假管理<span class="ico-red" v-if="holidayUnread != '0'">{{ holidayUnread }}</span></p>
          </div>
          <div class="tab" :class="{ 'active': mType == 7 }" @click="topTabFn(7)" v-if="MenuInclude('403')">
            <p>物品管理<span class="ico-red" v-if="assetUnread != '0'">{{ assetUnread }}</span></p>
          </div>
        </div>
      </div>
      <div class="message" :class="{ 'long': isLong }">
        <div class="list">
          <div class="left" style="cursor: pointer;">
            <div class="tab" :class="{ 'active': type == 1 }" @click="leftTabFn(1)">操作 ({{ optionUnread }})</div>
            <div class="tab" :class="{ 'active': type == 2 }" @click="leftTabFn(2)">通知 ({{ noticeUnread }})</div>
          </div>

          <div class="right">
            <div class="picker" v-if="isLong">
              <el-date-picker v-model="timer" type="datetimerange" range-separator="--" start-placeholder="开始日期"
                end-placeholder="结束日期" style="margin-right: 10px;" @change="getDetail(false)">
              </el-date-picker>
            </div>
            <div class="operator">
              <div>
                <el-button type="primary" round @click="showClear">一键已读</el-button>
              </div>
              <div>
                <el-input placeholder="请输入内容" v-model="keyValue" @keyup.enter.native="doSearch" clearable
                  @clear="doSearch"></el-input>
              </div>
            </div>
            <div class="tabbar" style="cursor: pointer;">
              <div class="tab" :class="{ 'active': status == 0 }" @click="rightTabFn(0)">全部</div>
              <div class="tab" :class="{ 'active': status == 1 }" @click="rightTabFn(1)">未读</div>
              <div class="tab" :class="{ 'active': status == 2 }" @click="rightTabFn(2)">已读</div>
            </div>
            <div class="rlist">
              <ul>
                <li v-for="(item, index) in itemList" :key="index" @click="setInfo(item)" style="cursor: pointer;"
                  :class="{ 'active': item.checked }">
                  <div class="ico-no" v-if="item.status == 1">未读</div>
                  <div class="word">
                    <el-popover placement="top-start" title="" width="400" trigger="hover" :content="item.word">
                      <span slot="reference">{{ item.word }}</span>
                    </el-popover>
                  </div>
                  <div class="time">{{ item.create_time }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="pane" :class="{ 'is-top': scrollTag }">
          <div class="pane-title">
            <a class="pane-btn back" style="cursor: pointer;" @click="setBack">标记为未读</a>
            <div class="el-icon-close" @click="clearInfo" style="cursor: pointer;"></div>
          </div>
          <div class="pane-con" v-html="infoArr.info"></div>
          <div class="pane-con operator"><span v-if="infoArr.operator_name">操作人：{{ infoArr.operator_name }}</span></div>
          <el-link class="pane-btn" :href="infoArr.go_url">{{ infoArr.button_name }}</el-link>
        </div>
        <div class="apage" style="height: 48px;box-sizing: border-box;">
          <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
            layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="一键已读" :visible.sync="clearShow" width="400px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>是否将{{ mType == '1' ? '客户项目' : (mType == '2' ? '行政采购' : (mType == '3' ? '人力资源' : '报销管理')) }}-{{ type ==
            '1' ?
            '操作' : '通知' }}下的{{ type == '1' ? optionUnread : noticeUnread }}条未读消息批量修改为已读</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearShow = false">取 消</el-button>
        <el-button type="primary" @click="doClear">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { thousands } from '@/utils/index.js'
export default {
  name: 'Home',
  data() {
    return {
      menuLimtList: [],
      nodeLimtList: [],
      newProjectList: [],
      oldYearList: [], // 本年之前的数据
      currentYearList: [], // 本年数据
      nextYearList: [], // 下一年及以后数据
      scrollTag: true,
      level: '',
      update_time: '', //取最后一个值的update时间
      customer: [],
      administrative: [],
      human_resources: [],
      reimbursement: [],
      perPage: 30,
      p: 1,
      total: 0,
      isLong: true,
      type: 1, //1操作 2通知
      mType: 1, //1 客户项目 2行政项目 3人力资源项目 4报销
      status: 0, //0全部 1未读 2已读
      timer: [],
      itemList: [],
      noticeUnread: '',
      optionUnread: '',
      projectUnread: "",
      adminUnread: "",
      hrUnread: "",
      expenseUnread: "",
      holidayUnread: "",
      assetUnread: "",
      infoArr: {
        info: '',
        button_name: '',
        go_url: '',
      },
      keyValue: '',
      clearShow: false,
      yearNow: '', // 动态年份分界点
      expandYearList: [2026,] // 存储已展开的年份列表
    }
  },
  components: {},
  computed: {},
  created() {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset + window.innerHeight + 300 >= document.body.offsetHeight) {
        this.scrollTag = false;
      } else {
        this.scrollTag = true
      }
    })
    //每5分钟刷新一次消息列表
    let timer
    timer = setInterval(() => {
      this.getDetail()
      console.log(timer);
    }, 300000);
  },
  mounted() {
    this.checkUrlFn()
    this.checkNodeFn('61')
    // 获取当前年份作为动态分界点
    var date = new Date()
    this.yearNow = date.getFullYear() //动态获取当前年份
    console.log(this.yearNow);
    this.expandYearList.push(this.yearNow)
    this.getNewList(this.yearNow)
    //500ms后根据权限展示首次看到的消息
    setTimeout(() => {
      this.getDetail()
    }, 500);
  },
  methods: {
    checkUrlFn() {
      const hash = window.location.hash;
      const url = hash.substring(1);
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    MenuInclude(val) {
      return this.menuLimtList.includes(val)
    },
    toApply(year, status, is_receive) {
      const form = {
        key: '',
        atype: 'contract_name',
        hope_time: ['', ''],
        year: year,
        status: status,
        is_receive: is_receive,
      }
      store.commit('setApplyData', JSON.parse(JSON.stringify(form)))
      this.$router.push({
        path: '/apply',
        query: {},
      })
    },
    toPay({ row }, pay_status) {
      const form = {
        key: '',
        atype: 'contract_name',
        hope_pay_time: ['', ''],
        pay_time: ['', ''],
        apply_amount_from: undefined,
        apply_amount_to: undefined,
        invoice_amount_from: undefined,
        invoice_amount_to: undefined,
        year: row.year,
        pay_status,
      }
      if (row.project_type == '1') {
        store.commit('setPayData', JSON.parse(JSON.stringify(form)))
        this.$router.push({
          path: '/pay',
          query: {},
        })
      } else if (row.project_type == '2') {
        store.commit('setAdPayData', JSON.parse(JSON.stringify(form)))
        this.$router.push({
          path: '/adPay',
          query: {},
        })
      } else if (row.project_type == '3') {
        store.commit('setHrPayData', JSON.parse(JSON.stringify(form)))
        this.$router.push({
          path: '/hrPay',
          query: {},
        })
      }
    },
    link(url) {
      this.$router.push(url)
    },
    getDetail() {
      const time = this.timer || []
      this.$fly
        .post('ApiIndex_getMessageList.html', {
          mType: this.mType,
          type: this.type,
          status: this.status,
          perPage: this.perPage,
          p: this.p,
          start_time: this.fdate(time[0]),
          end_time: this.fdate(time[1]),
          keyword: this.keyValue
        })
        .then((res) => {
          this.itemList = res.itemList.map(item => {
            item.word = item.info.split('<')[0]
            item.checked = false
            return item
          })
          this.total = +res.totalNum
          this.noticeUnread = Number(res.noticeUnread)
          this.optionUnread = Number(res.optionUnread)
          this.projectUnread = Number(res.projectUnread)
          this.adminUnread = Number(res.adminUnread)
          this.hrUnread = Number(res.hrUnread)
          this.expenseUnread = Number(res.expenseUnread)
          this.holidayUnread = Number(res.holidayUnread)
          this.assetUnread = Number(res.assestUnread)
        })
    },
    topTabFn(num) {
      this.p = 1
      this.isLong = true
      this.mType = num
      this.status = 0
      this.timer = []
      this.keyValue = ''
      this.getDetail()
    },
    leftTabFn(num) {
      this.p = 1
      this.isLong = true
      this.type = num
      this.status = 0
      this.timer = []
      this.keyValue = ''
      this.getDetail()
    },
    rightTabFn(num) {
      this.p = 1
      this.isLong = true
      this.status = num
      this.keyValue = ''
      this.getDetail()
    },
    setInfo(item) {
      this.itemList = this.itemList.map(_it => {
        _it.checked = false
        return _it
      })
      if (item.status == 1) {
        switch (Number(this.mType)) {
          case 1:
            this.projectUnread--
            break;
          case 2:
            this.adminUnread--
            break;
          case 3:
            this.hrUnread--
            break;
          case 4:
            this.expenseUnread--
            break;
          case 5:
            this.holidayUnread--
            break;
          case 7:
            this.assetUnread--
            break;
          default:
            break;
        }
      }
      this.$fly
        .post('apiAccount_updateMessage.html', {
          mid: item.id,
          status: 2,
        })
        .then(() => {
          this.infoArr = item
          this.isLong = false
          if (item.status == 1) {
            this.infoArr.type == 2 ? this.noticeUnread-- : this.optionUnread--
            item.status = 2
          }
          this.itemList = this.itemList.map(_it => {
            if (item === _it) {
              _it.checked = true
            }
            return _it
          })
        })
    },
    setBack() {
      this.$fly
        .post('apiAccount_updateMessage.html', {
          mid: this.infoArr.id,
          status: 1,
        })
        .then(() => {
          this.isLong = true
          this.infoArr.type == 2 ? this.noticeUnread++ : this.optionUnread++
          switch (Number(this.mType)) {
            case 1:
              this.projectUnread++
              break;
            case 2:
              this.adminUnread++
              break;
            case 3:
              this.hrUnread++
              break;
            case 4:
              this.expenseUnread++
              break;
            case 5:
              this.holidayUnread++
              break;
            case 7:
              this.assetUnread++
              break;
            default:
              break;
          }
          this.itemList = this.itemList.map(_it => {
            if (this.infoArr.id === _it.id) {
              _it.status = 1
            }
            return _it
          })
        })
    },
    clearInfo() {
      this.infoArr = {}
      this.isLong = true
    },
    // 获取年度数据
    getNewList(yearParam) {
      return new Promise((resolve) => {
        // 优先使用传入的年份参数，否则用默认年份
        const year = yearParam
        this.$fly
          .post('ApiIndex_getNewYearDataList', {
            year: year,
          })
          .then((res) => {
            // 取更新时间
            this.update_time = res.update_time || ''
            this.newProjectList = res.projectList
            let allYearData = []
            // 扁平化接口返回的嵌套数据结构
            Object.values(this.newProjectList).forEach(list => {
              list.forEach(yearItem => {
                if (yearItem.data && yearItem.data.length) {
                  yearItem.data.forEach(item => {
                    // 补充年份字段
                    item.year = yearItem.year
                    allYearData.push(item)
                  })
                }
              })
            })
            // 1. 本年之前数据（动态：< yearNow）
            this.oldYearList = allYearData
              // .filter(item => item.year < this.yearNow)
              .map(item => {
                // 千分位格式化
                item.total_amount = thousands(item.total_amount)
                item.received_amount = thousands(item.received_amount)
                item.unreceived_amount = thousands(item.unreceived_amount)
                item.total_invoice = thousands(item.total_invoice)
                item.unfinished_invoice = thousands(item.unfinished_invoice)
                item.invoice_unreceive = thousands(item.invoice_unreceive)
                item.total_budget = thousands(item.total_budget)
                item.total_cost = thousands(item.total_cost)
                item.total_paid = thousands(item.total_paid)
                item.total_no_paid = thousands(item.total_no_paid)
                item.isShow = true
                return item
              })

            // 2. 本年数据（动态：=== yearNow）
            // this.currentYearList = allYearData
            //   .filter(item => item.year === this.yearNow)
            //   .map(item => {
            //     // 千分位格式化
            //     item.total_amount = thousands(item.total_amount)
            //     item.received_amount = thousands(item.received_amount)
            //     item.unreceived_amount = thousands(item.unreceived_amount)
            //     item.total_invoice = thousands(item.total_invoice)
            //     item.unfinished_invoice = thousands(item.unfinished_invoice)
            //     item.invoice_unreceive = thousands(item.invoice_unreceive)
            //     item.total_budget = thousands(item.total_budget)
            //     item.total_cost = thousands(item.total_cost)
            //     item.total_paid = thousands(item.total_paid)
            //     item.total_no_paid = thousands(item.total_no_paid)
            //     item.isShow = true
            //     return item
            //   })

            // 3. 下一年及以后数据（动态：> yearNow）
            // this.nextYearList = allYearData
            //   .filter(item => item.year > this.yearNow)
            //   .map(item => {
            //     // 千分位格式化
            //     item.total_amount = thousands(item.total_amount)
            //     item.received_amount = thousands(item.received_amount)
            //     item.unreceived_amount = thousands(item.unreceived_amount)
            //     item.total_invoice = thousands(item.total_invoice)
            //     item.unfinished_invoice = thousands(item.unfinished_invoice)
            //     item.invoice_unreceive = thousands(item.invoice_unreceive)
            //     item.total_budget = thousands(item.total_budget)
            //     item.total_cost = thousands(item.total_cost)
            //     item.total_paid = thousands(item.total_paid)
            //     item.total_no_paid = thousands(item.total_no_paid)
            //     item.isShow = true
            //     return item
            //   })
            //取权限
            setTimeout(() => {
              this.level = store.state.level
              this.realName = store.state.realName
              this.menuLimtList = store.state.menuLimtList
              if (this.MenuInclude('2')) {
                this.mType = '1'
              } else if (this.MenuInclude('8')) {
                this.mType = '2'
              } else if (this.MenuInclude('16')) {
                this.mType = '4'
              } else if (this.MenuInclude('403')) {
                this.mType = '7'
              }
            }, 200);
            resolve(res)
          })
      })
    },
    // 切换年份展开/收起状态（支持多年份）
    toggleYearExpand(targetYear) {
      const isExpanded = this.expandYearList.includes(targetYear)
      if (isExpanded) {
        // 收起：从展开列表移除该年份
        this.expandYearList = this.expandYearList.filter(year => year !== targetYear)
      } else {
        // 展开：添加到展开列表
        this.expandYearList.push(targetYear)
      }

      // 拼接所有已展开年份 + 本年（动态）
      const yearParam = this.expandYearList.join(',')
      console.log(this.expandYearList);
      // 请求并更新数据
      this.getNewList(yearParam)
    },
    updateFn() {
      this.$fly
        .post('ApiIndex_modifyYearDataList.html', {})
        .then(() => {
          this.expandYearList.push(this.yearNow)
          this.getNewList(this.yearNow)
        })
    },
    showClear() {
      this.clearShow = true
    },
    doClear() {
      this.$fly
        .post('ApiIndex_readAllMessage.html', {
          mType: this.mType,
          type: this.type
        })
        .then(() => {
          this.clearShow = false
          this.p = 1
          this.isLong = true
          this.getDetail()
        })
    },
    doSearch() {
      this.p = 1
      this.isLong = true
      this.getDetail()
    },
    handleCurrentChange(p) {
      this.p = p
      this.getDetail()
    },
    handleChange() {
      this.getDetail()
    },
    // 补充缺失的fdate方法
    fdate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString()
    },
    tableRowClassName({row}) {
      if (row.project_type != '1' && row.project_type != '2' && row.project_type != '3' && row.project_type != '4') {
        return 'year-row';
      }
      return '';
    },
  },
}
</script>
<style lang="scss" scoped>
.main-title {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
}

.sub-title {
  padding: 40px 0 10px;
  font-size: 22px;
  font-weight: 700;
}

.filterwrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 20px 0;
}

.a-filter {
  width: 300px;
}

.b-filter {
  min-width: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font: 14px/1 $font;
}

.mybread {
  height: 48px;
  padding: 0 20px;
  @extend %center;
  @extend %box;
  margin-bottom: 20px;
  align-items: flex-start;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  color: #fff;

  .el-breadcrumb__inner a {
    color: $c;
  }
}

.table {
  margin-bottom: 30px;

  .items {
    &:last-of-type {
      .item {
        margin: 0;
      }
    }

    .item {
      margin-bottom: 50px;

      .item-title {
        font: 800 28px/2 $font;
        text-align: center;
      }
    }
  }
}

.tabpart {
  border-radius: 20px;
  margin-bottom: 20px;
  overflow: hidden;

  .top {
    padding-left: 150px;
    background: #ddd;

    &.margin {
      padding-left: 128px;
    }

    .topbar {
      @extend %start;
      justify-content: flex-start;

      height: 80px;

      .tab {
        width: 120px;
        height: 100%;
        line-height: 80px;
        border-radius: 10px 10px 0 0;
        text-align: center;
        background: transparent;


        &.active {
          background: #fff;
        }

        p {
          display: inline-block;
          font: 400 16px/28px $font;
          position: relative;

          .ico-red {
            display: inline-block;
            min-width: 14px;
            border-radius: 5px;
            padding: 0 2px;
            font: 600 12px/18px $font;
            text-align: center;
            background: red;
            color: #fff;
            position: absolute;
            right: -20%;
            top: -18px;
          }
        }
      }
    }
  }

  .message {
    width: 100%;
    height: 1400px;
    position: relative;
    @extend %center;
    flex-flow: row nowrap;

    &.long {
      .list {
        width: 100%;
        margin-right: 0;

        .left {
          width: 150px;
        }

        .right {
          width: calc(100% - 150px);
          height: 100%;

          .rlist {
            .word {
              width: 80%;
            }

            .time {
              display: block;
            }
          }
        }
      }

      .pane {
        display: none;
      }

      .apage {
        width: calc(100% - 150px - 40px);
      }
    }

    .list {
      width: 40%;
      height: 100%;
      margin-right: 20px;
      @extend %center;
      flex-flow: row nowrap;

      .left {
        box-sizing: border-box;
        width: 20%;
        height: 100%;
        padding: 80px 0;
        background-color: #ddd;

        .tab {
          width: 100%;
          height: 80px;
          line-height: 80px;

          &.active {
            background: #fff;
          }
        }
      }

      .right {
        box-sizing: border-box;
        width: 80%;
        height: 100%;
        padding: 20px;
        background-color: #fff;
        position: relative;

        .picker {
          position: absolute;
          right: 20px;
          top: 20px;
          z-index: 1;
        }

        .operator {
          @extend %start;
          position: absolute;
          left: 180px;
          top: 18px;
          z-index: 1;

          div {
            &:first-of-type {
              margin-right: 20px;
            }

            &:nth-of-type(2) {
              width: 200px;
            }
          }
        }

        .tabbar {
          height: 28px;
          @extend %center;
          flex-flow: row nowrap;
          justify-content: flex-start;
          position: absolute;
          top: 20px;
          left: 20px;
          z-index: 1;

          .tab {
            box-sizing: border-box;
            width: 50px;
            height: 28px;
            font: 600 16px/28px $font;
            color: #999;

            &.active {
              color: #000;
              border-bottom: 1px solid #000;
            }
          }
        }

        .rlist {
          box-sizing: border-box;
          width: calc(100% - 36px);
          height: 1280px;
          padding: 48px 0 0;
          position: absolute;
          left: 20px;
          top: 20px;
          z-index: 0;

          ul {
            padding: 0;
            width: 100%;
            height: 100%;
            overflow-y: scroll;

            &::-webkit-scrollbar {
              width: 2px;
            }

            &::-webkit-scrollbar-track {
              background-color: none;
            }

            &::-webkit-scrollbar-thumb {
              background-color: rgba(0, 0, 0, 0.5);
            }

            li {
              @extend %center;
              flex-flow: row nowrap;
              justify-content: space-between;
              padding: 0 60px;
              font: 400 12px/40px $font;
              position: relative;

              &:nth-of-type(2n) {
                background-color: #f2f2f2;
              }

              &:nth-of-type(2n-1) {
                background: #fff;
              }

              &.active {
                background: #0e0f22;
                color: #fff;

                .ico-no {
                  border-color: #fff;
                  color: #fff;
                }
              }

              .ico-no {
                box-sizing: border-box;
                width: 40px;
                height: 20px;
                border: 1px solid red;
                font: 12px/20px $font;
                color: red;
                position: absolute;
                left: 10px;
              }

              .word {
                width: 100%;
                text-align: left;
                box-sizing: border-box;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .time {
                display: none;
              }
            }
          }
        }
      }
    }

    .pane {
      box-sizing: border-box;
      width: calc(60% - 20px);
      height: 100%;
      padding: 5%;
      padding-top: 400px;
      background: #fff;
      position: relative;
      @extend %center;
      animation: showoff 1s ease-in;

      &.is-top {
        justify-content: flex-start;
        padding-top: 200px;
        animation: offshow 1s ease-in;
      }

      .pane-title {
        width: 100%;
        height: 60px;
        position: relative;

        .el-icon-close {
          width: 30px;
          height: 30px;
          font-size: 28px;
          font-weight: 700;
          position: absolute;
          top: 0;
          right: -5%;
        }
      }

      .pane-con {
        width: 100%;
        box-sizing: border-box;
        min-height: 150px;
        padding: 30px 30px 0;
        border-radius: 20px 20px 0 0;
        background: rgba(#606266, 0.2);

        &.operator {
          min-height: 50px;
          padding: 0 30px 30px;
          border-radius: 0 0 20px 20px;
        }
      }

      .pane-btn {
        display: inline-block;
        box-sizing: border-box;
        height: 30px;
        background: #409EFF;
        padding: 0 25px;
        margin: 20px auto 0;
        border-radius: 5px;
        font: 14px/30px $font;
        color: #fff;
        text-align: center;

        &:-webkit-any-link {
          text-decoration: none;
        }

        &::after {
          display: none;
        }

        &.back {
          margin: 0;
          position: absolute;
          left: -5%;
          top: 0;
        }
      }
    }

    .apage {
      width: calc(60% - 60px);
      position: absolute;
      right: 20px;
      bottom: 50px;
    }
  }
}

.el-range-editor--small.el-input__inner {
  height: 28px;
}

.el-range-editor.el-input__inner {
  padding: 1px 10px;
}

@keyframes showoff {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
    padding-top: 400px;
  }

  100% {
    opacity: 1;
    padding-top: 400px;
  }
}

@keyframes offshow {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
    padding-top: 200px;
  }

  100% {
    opacity: 1;
    padding-top: 200px;
  }
}
</style>
<style lang="scss">
.grey {
  color: #999 !important;
}

.item {
  position: relative;

  .item-button {
    position: absolute;
    top: 15px;
    right: 0;
  }
}
.el-table tr {
  &.year-row {
    // background: #d1d1d1;

    .el-table__cell {
      color: #000;
      font-weight: 700;
    }
  }
}
</style>